import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { ILoginState } from '@share/store/slices';
import { RootState } from '@share/utils';
import { Routes } from '@share/constants';
import CarsMain from '@share/assets/images/cars-main.jpg';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps {
  accountName: string;
}

function ModernPromotionalBannersComponent(props: IProps) {
  const { accountName } = props;

  return (
    <section className="modern-promotional-banners">
      <div className="modern-promotional-banners__container">
        <p className="modern-promotional-banners__label">FEATURED OPPORTUNITIES</p>

        {/* Cruise Banner */}
        <div className="modern-promotional-banners__item modern-promotional-banners__item--cruise">
          <div className="modern-promotional-banners__item-image modern-promotional-banners__item-image--cruise" />
          <div className="modern-promotional-banners__item-content">
            <div className="modern-promotional-banners__item-badge">
              <span className="modern-promotional-banners__item-badge-dot modern-promotional-banners__item-badge-dot--green" />
              1,419 ITINERARIES AVAILABLE
            </div>
            <h3 className="modern-promotional-banners__item-title">Ocean Travel Experiences</h3>
            <p className="modern-promotional-banners__item-description">
              Premium cruise packages with complimentary excursions, beverage programs, and
              specialty dining. Second passenger savings up to 67%.
            </p>
            <div className="modern-promotional-banners__item-actions">
              <Link
                to={`/${accountName}${Routes.Cruises}`}
                className="modern-promotional-banners__button modern-promotional-banners__button--primary"
              >
                Browse Itineraries
              </Link>
              <Link
                to={`/${accountName}${Routes.Cruises}`}
                className="modern-promotional-banners__button modern-promotional-banners__button--secondary"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>

        {/* Vacation Banner */}
        <div className="modern-promotional-banners__item modern-promotional-banners__item--vacation">
          <div className="modern-promotional-banners__item-content modern-promotional-banners__item-content--left">
            <div className="modern-promotional-banners__item-badge">
              <span className="modern-promotional-banners__item-badge-dot modern-promotional-banners__item-badge-dot--red" />
              LIMITED TIME OFFERS
            </div>
            <h3 className="modern-promotional-banners__item-title">Curated Accommodations</h3>
            <p className="modern-promotional-banners__item-description">
              200+ handpicked vacation properties with extraordinary discounts. First-come,
              first-served pricing from 24-67% off standard rates.
            </p>
            <div className="modern-promotional-banners__item-actions">
              <Link
                to={`/${accountName}${Routes.CondoSearch}`}
                className="modern-promotional-banners__button modern-promotional-banners__button--primary"
              >
                View Properties
              </Link>
              <button className="modern-promotional-banners__button modern-promotional-banners__button--secondary">
                Set Alert
              </button>
            </div>
          </div>
          <div className="modern-promotional-banners__item-image modern-promotional-banners__item-image--vacation" />
        </div>

        {/* Car Rentals Banner */}
        <div className="modern-promotional-banners__item modern-promotional-banners__item--cars">
          <div 
            className="modern-promotional-banners__item-image modern-promotional-banners__item-image--cars"
            style={{ backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.8), transparent), url(${CarsMain})` }}
          />
          <div className="modern-promotional-banners__item-content modern-promotional-banners__item-content--compact">
            <div className="modern-promotional-banners__item-header-compact">
              <div>
                <div className="modern-promotional-banners__item-badge">
                  <span className="modern-promotional-banners__item-badge-dot modern-promotional-banners__item-badge-dot--blue" />
                  GLOBAL FLEET ACCESS
                </div>
                <h3 className="modern-promotional-banners__item-title modern-promotional-banners__item-title--compact">
                  Ground Transportation Solutions
                </h3>
                <p className="modern-promotional-banners__item-description modern-promotional-banners__item-description--compact">
                  Premium vehicle rentals with complimentary upgrades and insurance. Zero hidden
                  fees, transparent pricing.
                </p>
              </div>
              <Link
                to={`/${accountName}${Routes.CarsSearch}`}
                className="modern-promotional-banners__button modern-promotional-banners__button--primary modern-promotional-banners__button--compact"
              >
                Reserve Vehicle
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
  };
};

export const ModernPromotionalBanners = connect(mapStateToProps)(ModernPromotionalBannersComponent);
